<script setup lang="ts">
import { BlockRichText } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{ block: BlockRichText }>()
</script>

<template>
  <div class="my-5 flex justify-center px-5 lg:px-[124px]">
    <CustomRichText
      class="text-lg leading-6 tracking-[-0.15px]"
      :transform-text="props.block.text"
    />
  </div>
</template>
